export const AUTH_REQUEST = "authReducer/AUTH_REQUEST";
export const AUTH_SUCCESS = "authReducer/AUTH_SUCCESS";
export const AUTH_FAILED = "authReducer/AUTH_FAILED";
